<template>
	<div>
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%;">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-button type="primary" v-has="'worklog:save'" @click="$refs.addForm._show()">添加日志</a-button>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="3">
								<a-col span="12">
									<a-date-picker valueFormat="YYYY-MM-DD" @change="getList" v-model="param.date" format="YYYY-MM-DD"  type="date" placeholder="请选择日期" />
								</a-col>
								<a-col span="12">
									<a-input v-model="param.keyword" allowClear search @pressEnter="getList"
										@on-clear="getList" placeholder="关键词查询"></a-input>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-table :columns="columns" :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false"
			:indentSize="25" :style="{ background: '#FFF' }" size="small" row-key="id" border ref="list" :loading="loading"
			:data-source="data.records">
			<template slot-scope="row" slot="author">
				<a @click="$refs.detail.show(row)">
					<span >{{ row.author }}</span>
				</a>
			</template>
			<template slot-scope="row" slot="content">
				<a @click="$refs.detail.show(row)">
					<span v-html="row.content.substr(0, 40)"></span>
				</a>
			</template>
			<!--操作-->
			<template slot-scope="row" slot="action">
				<a-button-group shape="circle" size="small">
					<a-tooltip title="修改"><a-button type="link" v-has="'worklog:save'" icon="edit"
						@click="$refs.addForm._show(row)"></a-button></a-tooltip>
				</a-button-group>
				<a-button-group shape="circle" size="small">
					<a-tooltip title="删除"><a-button type="link" v-has="'worklog:del'" icon="delete"
							@click="del(row.id)"></a-button></a-tooltip>
				</a-button-group>
			</template>
		</a-table>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
					@showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
		<addworklog-form ref="addForm" @success="doRefresh"></addworklog-form>
		<detail ref="detail"></detail>
	</div>
</template>

<script>
import apiUtil from '@/common/apiUtil';

import utils from '@/common/utils';

import addworklogForm from './components/addworklogForm.vue';
import detail from './components/detail.vue';
export default {
	components: { addworklogForm, detail },
	data() {
		return {
			data: {},
			loading: false,
			organList: apiUtil.getOrganList(),
			pageSizeOptions: ['10', '20', '30', '40', '50'],
			pageSize: 10,
			total: '',
			param: {
				current: 1,
				limit: 20,
				keyword: '',
				organId: '',
				date:''
			},
			columns: [
				{ title: 'ID', dataIndex: 'id', width: 80, ellipsis: true, align: 'center' },
				{ title: '姓名', scopedSlots: { customRender: 'author' }, width: 200, ellipsis: true, align: 'center' },
				// { title: '日志内容', scopedSlots: { customRender: 'content' }, ellipsis: true, align: 'left' },
				{ title: '日期', dataIndex: 'date', width: 160, ellipsis: true, align: 'center' },
				{ title: '发布时间', dataIndex: 'createTime', width: 260, ellipsis: true, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 }
			]
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		...apiUtil,
		// 获取车辆数据
		getList() {
			this.loading = true;
			this.http
				.get('/platform/work-log/list', this.param)
				.then(ret => {
					this.data = ret.data;
					this.total = data.total;
					this.param.current = data.current;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
				});
		},
		// 删除
		del(id) {
			this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
				utils.showSpin();
				this.http.delete('/platform/work-log/del/' + id).then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.getList();
						});
					}
				});
			});
		},
		// 筛选条件变化重新获取数据
		doRefresh() {
			this.param.current = 1;
			this.getList();
		},

		// 筛选单位
		filterOrgan(e) {
			this.param.organId = e;
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		}
	}
};
</script>
<style lang="less">
p {
	line-height: normal;
	padding: 0;
	margin: 0;
}
</style>